import snakeCaseKeys from "@/utils/snake-case-obj-keys"

export const PRE_SIGNUP_DATA_LOCAL_STORAGE_KEY = "preSignupData"

export const getters = {
  selectedTopics: (state) => state.userData.topics || [],
  preSignupDataJson: (state) => {
    let preSignupContent = {}
    try {
      // We load the preSignupContent from the localStorage that the blinkist-content-pages app might have written there.
      // !!! Note that we require the user's cookie-consent to leverage localStorage for this. !!!
      // Currently this is ensured in the content-pages app by preventing writing to localStorage when cookie consent is not given.
      // In blinkist-web itself we do not store pre-signup data into the localStorage so far.  [state: April 2023]
      preSignupContent = JSON.parse(localStorage.getItem(PRE_SIGNUP_DATA_LOCAL_STORAGE_KEY)) || {}
      // eslint-disable-next-line no-empty
    } catch (e) {}

    return JSON.stringify(
      snakeCaseKeys({
        ...preSignupContent,
        booksToAdd: Array.from(
          new Set(
            [
              ...(preSignupContent.booksToAdd || []),
              ...(state.userData.books || []),
              ...(state.userData.challengeBooks || []),
              ...(state.userData.likedBooks || [])
            ].map((b) => b.slug || b)
          )
        ),
        categoriesToFollow: Array.from(
          new Set([...(state.userData.topics || []), ...(preSignupContent.categoriesToFollow || [])])
        ),
        onboardingUserData: {
          ...state.userData,
          challengeBooks: state.userData.challengeBooks.map((b) => b.slug)
        }
      })
    )
  }
}
